import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/src/components/designSystem/SkeletonLoader'

export const PriceWatchSkeleton = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      height="100%"
      width="100%"
    >
      <div>
        <SkeletonLoader width={100} />
        <SkeletonLoader width={150} />
      </div>

      <Box
        display="flex"
        flexDirection="row"
        marginTop="s600"
        justifyContent="space-between"
        alignItems="baseline"
      >
        <SkeletonLoader width={90} />
        <SkeletonLoader width={40} marginTop={0} />
      </Box>
    </Box>
  )
}
